module.exports = __webpack_public_path__ + "img/Gb.2a7aec48.png";